import { Box, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import type { CSSProperties } from 'react';
import clsx from "clsx";
import React, { FC } from "react";
import { DroppableContainer } from "./components/DroppableContainer";

type StyleProps = {
  height?: CSSProperties["height"],
}

export const useStyles = makeStyles((theme: any) => ({
  paperContainer: (props: StyleProps) => ({
    border: `1px solid ${theme.palette.border.line}`,
    flex: 1,
    height: props.height ?? "25rem"
  }),
  titleList: {
    fontWeight: 500,
    fontSize: "0.9rem",
    color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
    padding: theme.spacing(0.5),
    textAlign: "center",
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.accent.main,
  },
  paperContainerToolbar: {
    display: 'flex',
    flexDirection: 'column'
  },
  informationContainer: {
    maxHeight: "90%", scrollbarWidth: "thin", overflowY: "scroll", padding: "0.5rem"
  },
  informationContainerToolbar: {
    maxHeight: 'none',
    flex: '1 1 auto',
    minHeight: 0
  },
  toolbar: {
    padding: theme.spacing(1)
  },
}));

type Props = {
  title: string,
  items: any[],
  droppableContainerId: string,
  height?: CSSProperties["height"],
  toolbar?: React.ReactNode,
  children: React.ReactNode
}

export const DroppableListContainer: FC<Props> = ({
  title, items, droppableContainerId, children, height, toolbar
}) => {
  const classes = useStyles({ height });
  const hasToolbar = Boolean(toolbar);

  return (
    <Paper className={clsx(classes.paperContainer, hasToolbar && classes.paperContainerToolbar)}>
      <Typography variant="body1" className={classes.titleList}>{title}</Typography>
      {toolbar && <Box className={classes.toolbar}>{toolbar}</Box>}
      <Box className={clsx(classes.informationContainer, hasToolbar && classes.informationContainerToolbar)}>
        <DroppableContainer items={items} id={droppableContainerId}>
          {children}
        </DroppableContainer>
      </Box>
    </Paper>
  );
};
